import { Flex } from '@workwhile/ui'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { filtersSchema, FiltersSchema } from './filtersSchema'
import { SearchButton } from './SearchButton'
import { PositionFilters } from './PositionFilters/PositionFilters'
import { CompanyFilters } from './CompanyFilters/CompanyFilters'
import { usePositionsContextValue } from '../../context/PositionsProvider'

export const PositionListFilters = () => {
  const {
    state: { positionFilters, companyFilters },
  } = usePositionsContextValue()

  const methods = useForm<FiltersSchema>({
    resolver: zodResolver(filtersSchema),
    reValidateMode: 'onChange',
    mode: 'all',
    defaultValues: {
      position: {
        positionIdUserInput: undefined,
        positionIds: [],
        status: 'all',
        prescreenStatus: 'all',
      },
      company: {
        companyIdUserInput: undefined,
        companyIds: [],
        companyGroupIdUserInput: undefined,
        companyGroupIds: [],
      },
    },
    values: {
      position: {
        positionIdUserInput: undefined,
        positionIds: positionFilters.positionIds.map((id) => ({ id })),
        status: positionFilters.status,
        prescreenStatus: positionFilters.prescreenStatus,
      },
      company: {
        companyIdUserInput: undefined,
        companyIds: companyFilters.companyIds.map((id) => ({ id })),
        companyGroupIdUserInput: undefined,
        companyGroupIds: companyFilters.companyGroupIds.map((id) => ({ id })),
      },
    },
  })

  return (
    <FormProvider {...methods}>
      <Flex
        as="form"
        flexDirection="row"
        gap={2}
        alignItems="center"
        onSubmit={(event) => {
          event.preventDefault()
        }}
      >
        <PositionFilters />
        <CompanyFilters />
        <SearchButton />
      </Flex>
    </FormProvider>
  )
}
